import React from 'react';
import { Accordion, InputLabel, Input, TooltipHelp } from '@weezevent/nacre';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { FormPreview } from '../../../../forms/components/formPreview';
import SeatIcon from '../InventoriesStep/ManualModal/ModalSummary/SeatIcon';
import useAppContext from '../../../../../context/useAppContext';
import css from '../../styles.module.css';

export default function AttendeeForm({
    attendee,
    form,
    fields,
    index,
    onChangeAttendee,
    onChangeFormAttendees,
    bookingSelectionAuto,
    setFullScreenMode = () => {},
    setSelectedZone = () => {},
    setPreviousZone = () => {},
    setBackToSeats = () => {},
    onChangeSteps = () => {}
}) {
    const { language: locale } = i18n;
    const { booking_uuid } = attendee;
    const { t } = useTranslation();
    const [{ event }] = useAppContext();

    const [previousFields, setPreviousFields] = React.useState(null);

    const renderTitle = React.useMemo(() => {
        if (form.use_inventories) {
            return (
                <span className={css['attendee-form-rate-title']}>
                    {!event.isFakeSeating() && <SeatIcon color={'black'} />}
                    {t('ticket.common.attendee')} {attendee.id}
                </span>
            );
        }
        return (
            <span className={css['attendee-form-rate-title']}>
                {t('ticket.common.attendee')} {index + 1}
            </span>
        );
    }, [attendee]);
    // we fill checkbox form fields with boolean value because default "0" & "1" values aren't saved when we don't change any field
    React.useEffect(() => {
        let defaultForm = {};
        if (fields !== null && fields !== previousFields) {
            fields.forEach(field => {
                if (field.form_field.field_type === 'checkbox') {
                    const defaultValue =
                        field.form_field.default_value === null || field.form_field.default_value === '0'
                            ? false
                            : field.form_field.default_value === '1'
                            ? true
                            : field.form_field.default_value;
                    defaultForm[field.form_field.weez_id] = defaultValue;
                }
            });
            onChangeFormAttendees(defaultForm);
            setPreviousFields(fields);
        }
    }, [previousFields, fields, onChangeFormAttendees]);

    const onchangeSeat = React.useCallback(() => {
        if (form.use_inventories && !bookingSelectionAuto) {
            setSelectedZone(form.selectedZone);
            setPreviousZone(form.previousZone);
            setBackToSeats(true);
            onChangeSteps(1);
            setFullScreenMode(true);
        }
    }, [form, bookingSelectionAuto, setSelectedZone, setPreviousZone, setBackToSeats, onChangeSteps, setFullScreenMode]);

    const seatInfos = React.useMemo(() => {
        if (!form.use_inventories) {
            return null;
        }
        return `- ${t('ticket.common.seating.seat')} ${booking_uuid.seat_seat} - ${t('ticket.common.seating.row')} ${booking_uuid.seat_row} - ${t(
            'ticket.common.seating.access'
        )} ${booking_uuid.seat_access}`;
    }, [form, booking_uuid]);

    const attendeePlacement = React.useMemo(() => {
        if (!form.use_inventories) {
            return null;
        }
        return `${booking_uuid.seat_zone_name !== undefined ? booking_uuid.seat_zone_name : booking_uuid.area_zone_name} - ${booking_uuid.rate_category_name} ${
            booking_uuid.seat_seat !== undefined ? seatInfos : ''
        }`;
    }, [attendee, form, seatInfos, booking_uuid]);

    return (
        <Accordion className={css['attendee-form-accordion']} disableToggle={true} openByDefault title={renderTitle}>
            <FormPreview fields={fields} form={attendee.form} onChangeForm={onChangeAttendee} locale={locale} usage={'attendee'} />
            {form.use_inventories && !event.isFakeSeating() && (
                <>
                    <InputLabel
                        className={css['attendee-form-rate-seating']}
                        label={
                            <span>
                                {t('main_menu_numeroted_seating')} <TooltipHelp title={attendeePlacement} />
                            </span>
                        }
                    />

                    <Input value={attendeePlacement} disabled />
                </>
            )}
            {form.use_inventories && !bookingSelectionAuto && (
                <span className={css['attendee-form-rate-back']} onClick={onchangeSeat}>
                    <SeatIcon color={'black'} />
                    {t('ticket.swapSeat.popup.ctaChangeSeat')}
                </span>
            )}
        </Accordion>
    );
}
